import appAxios from "./axios"

class AirportsService {
    getAll() {
        return appAxios.get(`/airports?`)
    }
}
export const airportsService = new AirportsService()